import { Review, ContentSection } from '@/components';
import { StyledContent } from '@/components/styles';
import { useTranslation } from 'react-i18next';
import { useLoadMore } from '@/hooks';
import { useEffect } from 'react';
import api from '@/lib/api';

const TitleReviews = ({ data: paginator, swiperData }) => {
  const { t } = useTranslation('global');
  const reviewsPaginator = useLoadMore(api.reviews, paginator, {}, true);
  const { loading, items, hasMore, handleLoadMore, page: currentPage } = reviewsPaginator;

  const { gallerySwiper } = swiperData;

  const updateSwiper = () => {
    if (gallerySwiper && gallerySwiper !== null && gallerySwiper.controller) {
      gallerySwiper.update();
    }
  };

  useEffect(() => {
    if (items?.length && !loading) {
      updateSwiper();
    }
  }, [items, loading]);

  return (
    <>
      <StyledContent.Reviews>
        <StyledContent.Loadable isLoading={loading}>
          {items && items.length > 0 ? (
            <ContentSection pb="x-small">
              {items.map((review) => {
                const { id, ...otherProps } = review;
                return <Review key={id} {...otherProps} />;
              })}
            </ContentSection>
          ) : (
            <StyledContent.Empty>{t('reviews.empty')}</StyledContent.Empty>
          )}
          <StyledContent.Actions>
            {hasMore && (
              <StyledContent.Link as="button" arrow onClick={() => handleLoadMore(currentPage)}>
                MORE REVIEWS
              </StyledContent.Link>
            )}
          </StyledContent.Actions>
        </StyledContent.Loadable>
      </StyledContent.Reviews>
    </>
  );
};

export default TitleReviews;
